export default {
  existing_documents: {
    description:
      'Olet jo ladannut seuraavat asiakirjat. Valitse yksi ja paina lähetä, tai lataa sen sijaan uusi asiakirja.',
    sides: {
      front: 'Etupuoli',
      back: 'Takapuoli',
    },
    created_at: 'Ladattu: {{date}}',
    expires_at: 'Vanhenee: {{date}}',
  },
  document_types: {
    owner_document: 'Omistajan henkilöllisyysasiakirja',
    business_document: 'Yritysasiakirja',
  },
  form: {
    document_type: {
      label: 'Henkilöllisyyden todistusasiakirja',
      placeholder: 'Valitse asiakirjan tyyppi',
      options: {
        passport: 'Passi',
        driver_license: 'Ajokortti',
        id_card: 'Henkilökortti',
        residence_permit: 'Oleskelulupa',
      },
    },
    front: {
      label: 'Asiakirjan etupuoli',
    },
    back: {
      label: 'Asiakirjan takapuoli (valinnainen joillekin asiakirjoille)',
    },
    expires_at: {
      label: 'Asiakirjan viimeinen voimassaolopäivä',
      placeholder: 'Valitse viimeinen voimassaolopäivä',
    },
  },
  buttons: {
    select_file: 'Valitse tiedosto',
    next: 'Seuraava',
    back: 'Takapuoli',
    send: 'Lähetä',
    upload_new: 'Lataa uusi asiakirja',
    use_existing: 'Käytä ladattua asiakirjaa',
  },
};
